import { getPaginatedResponseSchema, z } from '@betty/toolkit/api';

export const LevelSchema = z.object({
  level: z.number(),
  startPoints: z.number(),
  endPoints: z.number(),
});

export const LevelsResponseSchema = z
  .object({
    totalPoints: z.number(),
  })
  .extend(getPaginatedResponseSchema(LevelSchema).shape);
